// extracted by mini-css-extract-plugin
export default {"header":"ProductsList_header__g+awG","formList":"ProductsList_formList__rWnEW"};